<nb-card>
  <nb-card-header>
    Thông báo {{ mode == "tutor" ? " từ học viên" : "" }}

    <!-- <button
      nbButton
      ghost
      shape="round"
      status="primary"
      size="small"
      class="action-button"
      [disabled]="loading"
      [class.btn-pulse]="loading"
    >
      <nb-icon icon="more-horizontal-outline"></nb-icon>
    </button> -->
  </nb-card-header>

  <nb-card-body *ngIf="display.length > 0">
    <div class="row">
      <div *ngFor="let item of display; let i = index" class="col-md-12">
        <ngx-view-notification
          [notification]="item"
          [mode]="mode"
          (onDelete)="onDelete($event)"
          (onClose)="close($event)"
        ></ngx-view-notification>
      </div>

      <div class="col-md-12" *ngIf="loading">
        <ngx-view-placeholder></ngx-view-placeholder>
      </div>
    </div>
  </nb-card-body>

  <nb-card-body *ngIf="display.length == 0 && !loading">
    <div class="text-hint">Không có thông báo mới</div>
  </nb-card-body>

  <nb-card-footer *ngIf="!done && display.length > 0">
    <nb-actions size="small" class="see-more-button">
      <nb-action (click)="getMore()">
        <nb-icon class="action-icon" icon="more-horizontal-outline"></nb-icon>
        <span class="text-link">Xem thêm</span>
      </nb-action>
    </nb-actions>
  </nb-card-footer>
</nb-card>
